import React, { useEffect, useState } from 'react';
import queryString from 'query-string';
import PropTypes from 'prop-types';
import { doneChangingPaymentSource } from '@app/actions/purchase_details';
import AppGeneralPopup from '@common/app_general_popup';
import { asyncLoadScript } from '../../config/utils';
import { addSource } from '../../../app/actions/payment_sources';
import { useApplePayProcessing } from './use_apple_pay_processing';
import classes from './classes.module.scss';

const AddApplePayOption = ({
  topPadding, kind, context, analyticsEvents, onApplePayValidatedAction
}) => {
  const [loaded, setLoaded] = useState(false);
  const {
    startApplePayValidation, applePayValidated, error, resetError
  } = useApplePayProcessing();

  const handleApplePayClick = () => {
    setTimeout(() => {
      window.store.dispatch(addSource(kind));
    }, 500);
  };

  useEffect(() => {
    if (applePayValidated) {
      if (onApplePayValidatedAction) {
        onApplePayValidatedAction();
      }
      window.store.dispatch(doneChangingPaymentSource());
    }
  }, [applePayValidated]);

  const handleAppleMerchnantClick = () => {
    startApplePayValidation(context, analyticsEvents);
  };

  useEffect(() => {
    const applePayButton = document.querySelector('apple-pay-button');
    const action = kind === 'am' ? handleAppleMerchnantClick : handleApplePayClick;
    if (applePayButton) {
      applePayButton.addEventListener('click', action);
    }
    return () => {
      if (applePayButton) {
        applePayButton.removeEventListener('click', action);
      }
    };
  }, [loaded]);

  useEffect(() => {
    const scriptAlreadyExists = document.querySelector('script[src="https://applepay.cdn-apple.com/jsapi/v1/apple-pay-sdk.js"]');

    if (scriptAlreadyExists) {  // Check if Apple Pay SDK is already loaded
      setLoaded(true);
    } else {
      asyncLoadScript('https://applepay.cdn-apple.com/jsapi/v1/apple-pay-sdk.js')
        .then(() => {
          setLoaded(true);
        });
    }
  }, []);

  if (!loaded) {
    return null;
  }

  const buttonStyle = () => {
    const search = (queryString.parse(window.location.search) || {});
    return search?.theme === 'dark' ? 'white' : 'dark';
  };

  const errorPopup = () => {
    if (!error) return null;
    return (
      <AppGeneralPopup
        visible={ !!error }
      >
        <div className={ classes.errorContainer }>
          <div className={ classes.errorTitleContainer }>{error.error_name}</div>
          <div className={ classes.errorTextContainer }>{error.error}</div>
          <button type="button" onClick={ resetError } className={ classes.errorOkBtn }>OK</button>
        </div>
      </AppGeneralPopup>
    );
  };

  return (
    <>
      {errorPopup()}
      <style>
        {`
        apple-pay-button {
          --apple-pay-button-height: 44px;
          --apple-pay-button-border-radius: var(--app-default-btn-lg-border-radius);
          --apple-pay-button-padding: 6px 0px;
          --apple-pay-button-box-sizing: border-box;
          width: 100%;
          margin-top: ${ topPadding }px;
        }
      `}
      </style>
      <apple-pay-button
        buttonstyle={ buttonStyle() }
        type= { kind === 'am' ? 'set-up' : 'pay' }
        locale="en-US"
      />
    </>
  );
};

export default AddApplePayOption;

AddApplePayOption.propTypes = {
  topPadding: PropTypes.number,
  kind: PropTypes.oneOf(['ap', 'am']).isRequired,
  context: PropTypes.object,
  analyticsEvents: PropTypes.object,
  onApplePayValidatedAction: PropTypes.func

};

AddApplePayOption.defaultProps = {
  context: null,
  analyticsEvents: null,
  onApplePayValidatedAction: null,
  topPadding: 0
};
